import { EventEmitter } from '../utils/events.js';

/**
 * Gemeinsamer Zustand für die „besonderen Funde“ (Spotlight): hex → Urteil.
 * Geschrieben vom Hintergrund-Screener (data/aiScreener.js), gelesen von der
 * Karte (cesium/flightManager.js — Sternchen-Badge + Prioritäts-Filter) und dem
 * Info-Panel (ui/infoPanel.js — Badge in der Kurzansicht). Nur INTERESSANTE
 * Urteile landen hier; „gewöhnlich“ wird gar nicht erst eingetragen.
 *
 * @typedef {{ interesting:boolean, category:string, label:string, rarity:number, source:string }} Verdict
 */
export class SpotlightState extends EventEmitter {
  constructor() {
    super();
    this.verdicts = new Map(); // hex -> Verdict
  }

  set(hex, verdict) {
    const key = (hex || '').trim().toLowerCase();
    if (!key || !verdict) return;
    const prev = this.verdicts.get(key);
    this.verdicts.set(key, verdict);
    // Nur bei echter Änderung melden (spart Karten-Rerenders)
    if (!prev || prev.label !== verdict.label || prev.interesting !== verdict.interesting) {
      this.emit('change', { hex: key, verdict });
    }
  }

  get(hex) {
    return this.verdicts.get((hex || '').trim().toLowerCase()) || null;
  }

  isInteresting(hex) {
    const v = this.get(hex);
    return Boolean(v && v.interesting);
  }
}
